<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2 ">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">

    <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header">
      <h2 class="text-xl text-white font-semibold w-fit mb-0">Partners BTB</h2>
    </div>

    <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">
      <div class="flex mt-6 mb-6 inset-x-0 bottom-0">
        <div *ngIf="loadingPartners" class="w-full text-center">
          <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
        </div>

        <app-generic-list class="w-full flex-col" *ngIf="partnersList.length > 0 && !loadingPartners"
          filterKeyPrefix="partners"
          [items]="partnersList"
          (itemClick)="onPartnerClick($event)"
          [filterFields]="filterPartners"
          [showFilters]="true"
          [isFiltersCollapsed]="true"
          [allowDownload]="false"
          (filtersChanged)="onFiltersChanged($event)"
          (filteredCount)="filteredCounts.partnersList = $event"
          [pageSize]="10">

          <ng-template #tableHeaderTemplate>
            <div class="flex items-center border-b py-2 text-sm font-semibold text-gray-600 overflow-x-auto">
              <div class="w-[150px] mr-4">Nombre</div>
              <div class="w-[130px] mr-4">Teléfono</div>
              <div class="w-[200px] mr-4">Email</div>
              <div class="w-[120px] mr-4">Partner ID</div>
              <div class="w-[120px] mr-4">Estado</div>
              <div class="w-[110px]">Fecha Creación</div>
            </div>
          </ng-template>

          <ng-template #itemTemplate let-item>
            <div class="flex items-center border-b py-2 text-sm overflow-x-auto">
              <div class="w-[150px] truncate overflow-hidden whitespace-nowrap font-bold mr-4" [title]="getFullName(item)">
                {{ getFullName(item) }}
              </div>
              <div class="w-[130px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" [title]="item.phone">
                {{ item.phone }}
              </div>
              <div class="w-[200px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" [title]="item.email">
                {{ item.email }}
              </div>
              <div class="w-[120px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" [title]="item.partnerId">
                {{ item.partnerId }}
              </div>
              <div class="w-[120px] truncate overflow-hidden whitespace-nowrap mr-4">
                {{ item.userStatus }}
              </div>
              <div class="w-[110px] truncate overflow-hidden whitespace-nowrap" *ngIf="item.userCreateDate">
                {{ item.userCreateDate | date:'dd/MM/yyyy' }}
              </div>
            </div>
          </ng-template>

          <div *ngIf="filteredCounts.partnersList == 0 && !loadingPartners" class="w-full content-center h-[200px]">
            <div class="!font-medium text-center">
              <mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">business</mat-icon><br />
              No se encontraron partners
            </div>
          </div>
        </app-generic-list>

        </div>
    </div>

  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>